module.exports = __webpack_public_path__ + "static/img/21-0623-cover.424588c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/21-0623-cover.jpg
// module id = Fc7e
// module chunks = 0